export const IS_IN_GOOGLE_AUTH = "IS_IN_GOOGLE_AUTH";

export const IS_IN_LINKEDIN_AUTH = "IS_IN_LINKEDIN_AUTH";

// Use this map to find new remo floor plan when user is cloning event with disabled floor plan
export const NEW_REMO_FP_MAP: Record<string, string> = {
  "4-SLOT-CONFERENCE": "4-SPONSOR-NEW",
  "6-SLOT-CONFERENCE": "6-SPONSOR-NEW",
  CONFERENCE: "DEFAULT-NEW",
  CODE1: "MODERN-1-NEW",
  CODE2: "MODERN-2-NEW",
  CODE3: "MODERN-3-NEW",
  CODE4: "MODERN-4-NEW",
  "MODERN-5": "MODERN-5-NEW",
  "MODERN-6": "MODERN-5-NEW",
  "MODERN-BROWN": "MODERN-BROWN-NEW",
  "MODERN-PURPLE": "MODERN-PURPLE-NEW",
  "MODERN-PURPLE-2": "MODERN-PURPLE-2-NEW",
  "MODERN-PURPLE-3-FINAL": "MODERN-PURPLE-3-NEW",
  "REMO-CHRISTMAS-MAP": "REMO-CHRISTMAS-NEW",
  "REMO-LIGHT-PINK": "MODERN-PINK-NEW",
  "REMO-MARKET": "MARKET-NEW",
  // staging
  "MODERN-5-V1": "MODERN-5-NEW",
  "MODERN-6-V1": "MODERN-6-NEW",
  "DEC-1-CHRISTMAS-MAP": "REMO-CHRISTMAS-NEW",
  "DEC-7-NEW-COLOR-STAGING": "MODERN-PURPLE-3-NEW",
};

export const SOCIAL_AUTH_PROVIDERS = {
  GOOGLE: "Google",
  FACEBOOK: "Facebook",
  LINKEDIN: "LinkedIn",
  MICROSOFT: "Microsoft",
  EDC: "Events.com",
};
